import styled from 'styled-components';

interface ISearchElementProps {
  maxWidth?: number;
}

export const SearchMenuElement = styled.div`
  position: relative;
`;

export const SearchElement = styled.div<ISearchElementProps>`
  max-width: ${props => props.maxWidth || 320}px;
  min-width: 200px;
  height: 40px;
  font-weight: 300;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  margin: 5px !important; /* Don't like !important (Antipattern tbh) but need to override weird Group component margin logic */
  flex: 1;
`;

export const SearchInputElement = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.vars.newColor.white};
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  border-radius: 5px;
  flex: 1;
  height: 40px;
  .iconClick {
    padding: 13px;
    cursor: pointer;
  }
`;

export const InputElement = styled.input`
  font-weight: 600;
  font-size: 16px;
  padding: 10px;
  border: none;
  outline: none;
  color: #1a1d1f;
  background-color: transparent;
  width: 100%;
  &::placeholder {
    font-weight: 400;
    color: #93abbc;
  }
`;

export const SearchMenuListElement = styled.ul`
  position: absolute;
  margin: 0;
  padding: 0;
  margin-top: 5px;
  border: 1px solid whitesmoke;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.3);
  left: 2px;
  right: 2px;
  border-radius: 5px;
  overflow-y: auto;
  background-color: white;
  text-decoration: none;
  margin-bottom: 30px;
  z-index: 10;

  &&& a {
    background-color: white;
    padding: 0;
    margin: 0;
    text-decoration: none;
  }
`;
